module.exports = "/_next/static/images/b48f37af3d4e599be93d8cbeba8b6f14-pj-phone-and-business-card@3x.jpg.webp";